var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-panel"},[_c('search-input'),_c('user-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }